<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { GroupList, GetScheduleTasks, GetGroupPlanDetails } from './api/index'
import { hasNotifiedToday, setNotifiedToday, isAllPlansCompleted } from './utils/planNotification'

export default {
  name: 'App',
  data() {
    return {
      pollTimer: null
    }
  },
  mounted() {
    // 启动定时轮询，每2分钟检查一次计划任务状态
    this.startPolling()
  },
  beforeDestroy() {
    this.stopPolling()
  },
  methods: {
    // 启动轮询
    startPolling() {
      // 立即执行一次
      this.checkAllGroupsPlanStatus()
      // 每2分钟执行一次 (60000ms)
      this.pollTimer = setInterval(() => {
        this.checkAllGroupsPlanStatus()
      }, 60000)
    },
    // 停止轮询
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
    },
    // 检查所有开启了计划任务的组的状态
    async checkAllGroupsPlanStatus() {
      try {
        // 1. 获取所有组列表
        const groupRes = await GroupList()
        const groups = groupRes.data || []
        
        // 2. 筛选出开启了计划任务的组
        const activeGroups = []
        const checkPromises = groups.map(async (group) => {
          try {
            const scheduleRes = await GetScheduleTasks(group.name)
            const configs = scheduleRes.data.configs
            if (configs && configs !== '') {
              const data = JSON.parse(configs)
              if (data.ison) {
                activeGroups.push({
                  name: group.name,
                  plans: data.plans || []
                })
              }
            }
          } catch (e) {
            // 忽略获取失败的情况
          }
        })
        await Promise.all(checkPromises)

        // 3. 对每个开启了计划任务的组，检查完成状态
        for (const group of activeGroups) {
          // 如果今天已经弹过提示，跳过
          if (hasNotifiedToday(group.name)) {
            continue
          }

          try {
            const detailsRes = await GetGroupPlanDetails(group.name)
            const detailsList = detailsRes.data || []
            
            // 构造与 Groups.vue 中相同的 statusList 格式
            const planCountMap = {}
            group.plans.forEach(plan => {
              planCountMap[plan.target] = plan.targetCount || 0
            })

            const statusList = detailsList.map(item => ({
              target: item.target || '',
              transformType: item.transformType || '',
              count: planCountMap[item.target] || 0,
              currentCount: item.count || 0
            }))

            // 检查是否全部达成
            if (isAllPlansCompleted(statusList)) {
              // 标记今天已弹出
              setNotifiedToday(group.name)
              // 使用 Element UI 的 $alert 弹出全局提示框
              this.$alert(`${group.name}组计划任务已全部达成`, '计划任务完成', {
                confirmButtonText: '我知道了',
                type: 'success',
                center: true,
                dangerouslyUseHTMLString: false
              })
            }
          } catch (e) {
            // 忽略获取详情失败的情况
          }
        }
      } catch (e) {
        // 忽略整体失败的情况
        console.log('全局计划任务检查失败:', e)
      }
    }
  }
}
</script>
